import * as Sentry from '@sentry/react-native';

// Trim so trailing newline/space from env (e.g. Vercel) doesn't break the ingest URL (404)
const DSN = typeof process.env.EXPO_PUBLIC_SENTRY_DSN === 'string'
  ? process.env.EXPO_PUBLIC_SENTRY_DSN.trim()
  : undefined;
const ENV = process.env.EXPO_PUBLIC_ENV || 'development';

export function initSentry() {
  if (!DSN) {
    if (__DEV__) {
      console.log('[Sentry] Skipping init: EXPO_PUBLIC_SENTRY_DSN not set');
    }
    return;
  }

  Sentry.init({
    dsn: DSN,
    environment: ENV,
    enableInExpoDevelopment: false,
    sendDefaultPii: false,
    debug: process.env.EXPO_PUBLIC_SENTRY_DEBUG === 'true',
    beforeSend(event) {
      const message = event.exception?.values?.[0]?.value || '';
      const type = event.exception?.values?.[0]?.type || '';

      // Suppress Supabase auth session errors (expected when no session exists)
      if (
        message.includes('Auth session missing') ||
        message.includes('Invalid Refresh Token') ||
        message.includes('Refresh Token Not Found') ||
        type.includes('AuthSessionMissingError') ||
        type.includes('AuthApiError')
      ) {
        return null;
      }

      return event;
    },
  });
}

export { Sentry };
